/**
 * @generated SignedSource<<7629e63140da49dae72c2551315deb9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "VibeFollowers",
    "kind": "LinkedField",
    "name": "followUser",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "follower",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followingCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "following",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followersCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followingUser",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "postItemFollowButtonFollowUserMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "postItemFollowButtonFollowUserMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "bec8a21e968958e1867e9a9b812ec68a",
    "id": null,
    "metadata": {},
    "name": "postItemFollowButtonFollowUserMutation",
    "operationKind": "mutation",
    "text": "mutation postItemFollowButtonFollowUserMutation(\n  $userId: String!\n) {\n  followUser(userId: $userId) {\n    id\n    follower {\n      id\n      followingCount\n    }\n    following {\n      id\n      followersCount\n      followingUser\n    }\n  }\n}\n"
  }
};
})();

node.hash = "715c9f5a770e68a559e2555db42b64d5";

module.exports = node;
